import { DataBean } from "../DataBean";

export class CalendarValues extends DataBean {



    public async getActualCalendarValues(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getActualCalendarValues_Number", [id]);
    }

}